// source: stailer/externaladminrpc/delivery_time.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var stailer_externaladminrpc_delivery_area_group_pb = require('../../stailer/externaladminrpc/delivery_area_group_pb.js');
goog.object.extend(proto, stailer_externaladminrpc_delivery_area_group_pb);
var type_delivery_fee_range_pb = require('../../type/delivery_fee_range_pb.js');
goog.object.extend(proto, type_delivery_fee_range_pb);
var type_price_type_pb = require('../../type/price_type_pb.js');
goog.object.extend(proto, type_price_type_pb);
var type_staff_task_group_pb = require('../../type/staff_task_group_pb.js');
goog.object.extend(proto, type_staff_task_group_pb);
var type_receive_method_pb = require('../../type/receive_method_pb.js');
goog.object.extend(proto, type_receive_method_pb);
goog.exportSymbol('proto.stailer_external_admin.DeliveryTime', null, global);
goog.exportSymbol('proto.stailer_external_admin.DeliveryTime.Status', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.stailer_external_admin.DeliveryTime = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.stailer_external_admin.DeliveryTime.repeatedFields_, null);
};
goog.inherits(proto.stailer_external_admin.DeliveryTime, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.stailer_external_admin.DeliveryTime.displayName = 'proto.stailer_external_admin.DeliveryTime';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.stailer_external_admin.DeliveryTime.repeatedFields_ = [19,26];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.stailer_external_admin.DeliveryTime.prototype.toObject = function(opt_includeInstance) {
  return proto.stailer_external_admin.DeliveryTime.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.stailer_external_admin.DeliveryTime} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.DeliveryTime.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    deliveryFrom: (f = msg.getDeliveryFrom()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    deliveryTo: (f = msg.getDeliveryTo()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    orderDeadline: (f = msg.getOrderDeadline()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    isDropOff: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
    limit: jspb.Message.getFieldWithDefault(msg, 7, 0),
    reservationCount: jspb.Message.getFieldWithDefault(msg, 8, 0),
    staffTaskGroupType: jspb.Message.getFieldWithDefault(msg, 10, 0),
    deliveryOrder: jspb.Message.getFieldWithDefault(msg, 11, 0),
    deliveryCarCount: jspb.Message.getFieldWithDefault(msg, 12, 0),
    pickingPackingPartitionCount: jspb.Message.getFieldWithDefault(msg, 14, 0),
    name: jspb.Message.getFieldWithDefault(msg, 15, ""),
    exclusiveUserId: jspb.Message.getFieldWithDefault(msg, 16, ""),
    exclusiveUserName: jspb.Message.getFieldWithDefault(msg, 17, ""),
    isDeletable: jspb.Message.getBooleanFieldWithDefault(msg, 18, false),
    deliveryFeeRangesList: jspb.Message.toObjectList(msg.getDeliveryFeeRangesList(),
    type_delivery_fee_range_pb.DeliveryFeeRange.toObject, includeInstance),
    deliveryFeeType: jspb.Message.getFieldWithDefault(msg, 20, 0),
    status: jspb.Message.getFieldWithDefault(msg, 22, 0),
    avoidOrderAssignDeliveryCarCount: jspb.Message.getFieldWithDefault(msg, 23, 0),
    isPublished: jspb.Message.getBooleanFieldWithDefault(msg, 24, false),
    shopId: jspb.Message.getFieldWithDefault(msg, 25, ""),
    deliveryAreaGroupsList: jspb.Message.toObjectList(msg.getDeliveryAreaGroupsList(),
    stailer_externaladminrpc_delivery_area_group_pb.DeliveryAreaGroup.toObject, includeInstance),
    receiveMethod: (f = msg.getReceiveMethod()) && type_receive_method_pb.ReceiveMethod.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of DeliveryTime as accepted by the `fromObject` method.
 * @record
 */
proto.stailer_external_admin.DeliveryTime.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.id;

  /** @type {?|undefined} */
  this.deliveryFrom;

  /** @type {?|undefined} */
  this.deliveryTo;

  /** @type {?|undefined} */
  this.orderDeadline;

  /** @type {?|undefined} */
  this.isDropOff;

  /** @type {?|undefined} */
  this.limit;

  /** @type {?|undefined} */
  this.reservationCount;

  /** @type {?|undefined} */
  this.staffTaskGroupType;

  /** @type {?|undefined} */
  this.deliveryOrder;

  /** @type {?|undefined} */
  this.deliveryCarCount;

  /** @type {?|undefined} */
  this.pickingPackingPartitionCount;

  /** @type {?|undefined} */
  this.name;

  /** @type {?|undefined} */
  this.exclusiveUserId;

  /** @type {?|undefined} */
  this.exclusiveUserName;

  /** @type {?|undefined} */
  this.isDeletable;

  /** @type {?|undefined} */
  this.deliveryFeeRangesList;

  /** @type {?|undefined} */
  this.deliveryFeeType;

  /** @type {?|undefined} */
  this.status;

  /** @type {?|undefined} */
  this.avoidOrderAssignDeliveryCarCount;

  /** @type {?|undefined} */
  this.isPublished;

  /** @type {?|undefined} */
  this.shopId;

  /** @type {?|undefined} */
  this.deliveryAreaGroupsList;

  /** @type {?|undefined} */
  this.receiveMethod;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.stailer_external_admin.DeliveryTime.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.stailer_external_admin.DeliveryTime}
 */
proto.stailer_external_admin.DeliveryTime.fromObject = function(obj) {
  var msg = new proto.stailer_external_admin.DeliveryTime();
  obj.id != null && jspb.Message.setField(msg, 1, obj.id);
  obj.deliveryFrom && jspb.Message.setWrapperField(
      msg, 2, google_protobuf_timestamp_pb.Timestamp.fromObject(obj.deliveryFrom));
  obj.deliveryTo && jspb.Message.setWrapperField(
      msg, 3, google_protobuf_timestamp_pb.Timestamp.fromObject(obj.deliveryTo));
  obj.orderDeadline && jspb.Message.setWrapperField(
      msg, 4, google_protobuf_timestamp_pb.Timestamp.fromObject(obj.orderDeadline));
  obj.isDropOff != null && jspb.Message.setField(msg, 6, obj.isDropOff);
  obj.limit != null && jspb.Message.setField(msg, 7, obj.limit);
  obj.reservationCount != null && jspb.Message.setField(msg, 8, obj.reservationCount);
  obj.staffTaskGroupType != null && jspb.Message.setField(msg, 10, obj.staffTaskGroupType);
  obj.deliveryOrder != null && jspb.Message.setField(msg, 11, obj.deliveryOrder);
  obj.deliveryCarCount != null && jspb.Message.setField(msg, 12, obj.deliveryCarCount);
  obj.pickingPackingPartitionCount != null && jspb.Message.setField(msg, 14, obj.pickingPackingPartitionCount);
  obj.name != null && jspb.Message.setField(msg, 15, obj.name);
  obj.exclusiveUserId != null && jspb.Message.setField(msg, 16, obj.exclusiveUserId);
  obj.exclusiveUserName != null && jspb.Message.setField(msg, 17, obj.exclusiveUserName);
  obj.isDeletable != null && jspb.Message.setField(msg, 18, obj.isDeletable);
  obj.deliveryFeeRangesList && jspb.Message.setRepeatedWrapperField(
      msg, 19, obj.deliveryFeeRangesList.map(
          type_delivery_fee_range_pb.DeliveryFeeRange.fromObject));
  obj.deliveryFeeType != null && jspb.Message.setField(msg, 20, obj.deliveryFeeType);
  obj.status != null && jspb.Message.setField(msg, 22, obj.status);
  obj.avoidOrderAssignDeliveryCarCount != null && jspb.Message.setField(msg, 23, obj.avoidOrderAssignDeliveryCarCount);
  obj.isPublished != null && jspb.Message.setField(msg, 24, obj.isPublished);
  obj.shopId != null && jspb.Message.setField(msg, 25, obj.shopId);
  obj.deliveryAreaGroupsList && jspb.Message.setRepeatedWrapperField(
      msg, 26, obj.deliveryAreaGroupsList.map(
          stailer_externaladminrpc_delivery_area_group_pb.DeliveryAreaGroup.fromObject));
  obj.receiveMethod && jspb.Message.setWrapperField(
      msg, 27, type_receive_method_pb.ReceiveMethod.fromObject(obj.receiveMethod));
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.stailer_external_admin.DeliveryTime}
 */
proto.stailer_external_admin.DeliveryTime.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.stailer_external_admin.DeliveryTime;
  return proto.stailer_external_admin.DeliveryTime.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.stailer_external_admin.DeliveryTime} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.stailer_external_admin.DeliveryTime}
 */
proto.stailer_external_admin.DeliveryTime.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDeliveryFrom(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDeliveryTo(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setOrderDeadline(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsDropOff(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLimit(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setReservationCount(value);
      break;
    case 10:
      var value = /** @type {!proto.type.StaffTaskGroup.Type} */ (reader.readEnum());
      msg.setStaffTaskGroupType(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDeliveryOrder(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDeliveryCarCount(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPickingPackingPartitionCount(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setExclusiveUserId(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setExclusiveUserName(value);
      break;
    case 18:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsDeletable(value);
      break;
    case 19:
      var value = new type_delivery_fee_range_pb.DeliveryFeeRange;
      reader.readMessage(value,type_delivery_fee_range_pb.DeliveryFeeRange.deserializeBinaryFromReader);
      msg.addDeliveryFeeRanges(value);
      break;
    case 20:
      var value = /** @type {!proto.type.PriceType} */ (reader.readEnum());
      msg.setDeliveryFeeType(value);
      break;
    case 22:
      var value = /** @type {!proto.stailer_external_admin.DeliveryTime.Status} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 23:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAvoidOrderAssignDeliveryCarCount(value);
      break;
    case 24:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsPublished(value);
      break;
    case 25:
      var value = /** @type {string} */ (reader.readString());
      msg.setShopId(value);
      break;
    case 26:
      var value = new stailer_externaladminrpc_delivery_area_group_pb.DeliveryAreaGroup;
      reader.readMessage(value,stailer_externaladminrpc_delivery_area_group_pb.DeliveryAreaGroup.deserializeBinaryFromReader);
      msg.addDeliveryAreaGroups(value);
      break;
    case 27:
      var value = new type_receive_method_pb.ReceiveMethod;
      reader.readMessage(value,type_receive_method_pb.ReceiveMethod.deserializeBinaryFromReader);
      msg.setReceiveMethod(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.stailer_external_admin.DeliveryTime.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.stailer_external_admin.DeliveryTime.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.stailer_external_admin.DeliveryTime} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.DeliveryTime.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDeliveryFrom();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getDeliveryTo();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getOrderDeadline();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getIsDropOff();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getReservationCount();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getStaffTaskGroupType();
  if (f !== 0.0) {
    writer.writeEnum(
      10,
      f
    );
  }
  f = message.getDeliveryOrder();
  if (f !== 0) {
    writer.writeInt64(
      11,
      f
    );
  }
  f = message.getDeliveryCarCount();
  if (f !== 0) {
    writer.writeInt64(
      12,
      f
    );
  }
  f = message.getPickingPackingPartitionCount();
  if (f !== 0) {
    writer.writeInt64(
      14,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getExclusiveUserId();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getExclusiveUserName();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getIsDeletable();
  if (f) {
    writer.writeBool(
      18,
      f
    );
  }
  f = message.getDeliveryFeeRangesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      19,
      f,
      type_delivery_fee_range_pb.DeliveryFeeRange.serializeBinaryToWriter
    );
  }
  f = message.getDeliveryFeeType();
  if (f !== 0.0) {
    writer.writeEnum(
      20,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      22,
      f
    );
  }
  f = message.getAvoidOrderAssignDeliveryCarCount();
  if (f !== 0) {
    writer.writeInt64(
      23,
      f
    );
  }
  f = message.getIsPublished();
  if (f) {
    writer.writeBool(
      24,
      f
    );
  }
  f = message.getShopId();
  if (f.length > 0) {
    writer.writeString(
      25,
      f
    );
  }
  f = message.getDeliveryAreaGroupsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      26,
      f,
      stailer_externaladminrpc_delivery_area_group_pb.DeliveryAreaGroup.serializeBinaryToWriter
    );
  }
  f = message.getReceiveMethod();
  if (f != null) {
    writer.writeMessage(
      27,
      f,
      type_receive_method_pb.ReceiveMethod.serializeBinaryToWriter
    );
  }
};


/**
 * @enum {number}
 */
proto.stailer_external_admin.DeliveryTime.Status = {
  AVAILABLE: 0,
  NOT_AVAILABLE: 1,
  AVAILABLE_SLIGHTLY: 2
};

/**
 * optional string id = 1;
 * @return {string}
 */
proto.stailer_external_admin.DeliveryTime.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.stailer_external_admin.DeliveryTime} returns this
 */
proto.stailer_external_admin.DeliveryTime.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.Timestamp delivery_from = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.stailer_external_admin.DeliveryTime.prototype.getDeliveryFrom = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.stailer_external_admin.DeliveryTime} returns this
*/
proto.stailer_external_admin.DeliveryTime.prototype.setDeliveryFrom = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.stailer_external_admin.DeliveryTime} returns this
 */
proto.stailer_external_admin.DeliveryTime.prototype.clearDeliveryFrom = function() {
  return this.setDeliveryFrom(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.stailer_external_admin.DeliveryTime.prototype.hasDeliveryFrom = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.Timestamp delivery_to = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.stailer_external_admin.DeliveryTime.prototype.getDeliveryTo = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.stailer_external_admin.DeliveryTime} returns this
*/
proto.stailer_external_admin.DeliveryTime.prototype.setDeliveryTo = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.stailer_external_admin.DeliveryTime} returns this
 */
proto.stailer_external_admin.DeliveryTime.prototype.clearDeliveryTo = function() {
  return this.setDeliveryTo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.stailer_external_admin.DeliveryTime.prototype.hasDeliveryTo = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.Timestamp order_deadline = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.stailer_external_admin.DeliveryTime.prototype.getOrderDeadline = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.stailer_external_admin.DeliveryTime} returns this
*/
proto.stailer_external_admin.DeliveryTime.prototype.setOrderDeadline = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.stailer_external_admin.DeliveryTime} returns this
 */
proto.stailer_external_admin.DeliveryTime.prototype.clearOrderDeadline = function() {
  return this.setOrderDeadline(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.stailer_external_admin.DeliveryTime.prototype.hasOrderDeadline = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional bool is_drop_off = 6;
 * @return {boolean}
 */
proto.stailer_external_admin.DeliveryTime.prototype.getIsDropOff = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.stailer_external_admin.DeliveryTime} returns this
 */
proto.stailer_external_admin.DeliveryTime.prototype.setIsDropOff = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional int64 limit = 7;
 * @return {number}
 */
proto.stailer_external_admin.DeliveryTime.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.stailer_external_admin.DeliveryTime} returns this
 */
proto.stailer_external_admin.DeliveryTime.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int64 reservation_count = 8;
 * @return {number}
 */
proto.stailer_external_admin.DeliveryTime.prototype.getReservationCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.stailer_external_admin.DeliveryTime} returns this
 */
proto.stailer_external_admin.DeliveryTime.prototype.setReservationCount = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional type.StaffTaskGroup.Type staff_task_group_type = 10;
 * @return {!proto.type.StaffTaskGroup.Type}
 */
proto.stailer_external_admin.DeliveryTime.prototype.getStaffTaskGroupType = function() {
  return /** @type {!proto.type.StaffTaskGroup.Type} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {!proto.type.StaffTaskGroup.Type} value
 * @return {!proto.stailer_external_admin.DeliveryTime} returns this
 */
proto.stailer_external_admin.DeliveryTime.prototype.setStaffTaskGroupType = function(value) {
  return jspb.Message.setProto3EnumField(this, 10, value);
};


/**
 * optional int64 delivery_order = 11;
 * @return {number}
 */
proto.stailer_external_admin.DeliveryTime.prototype.getDeliveryOrder = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.stailer_external_admin.DeliveryTime} returns this
 */
proto.stailer_external_admin.DeliveryTime.prototype.setDeliveryOrder = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional int64 delivery_car_count = 12;
 * @return {number}
 */
proto.stailer_external_admin.DeliveryTime.prototype.getDeliveryCarCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.stailer_external_admin.DeliveryTime} returns this
 */
proto.stailer_external_admin.DeliveryTime.prototype.setDeliveryCarCount = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional int64 picking_packing_partition_count = 14;
 * @return {number}
 */
proto.stailer_external_admin.DeliveryTime.prototype.getPickingPackingPartitionCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.stailer_external_admin.DeliveryTime} returns this
 */
proto.stailer_external_admin.DeliveryTime.prototype.setPickingPackingPartitionCount = function(value) {
  return jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional string name = 15;
 * @return {string}
 */
proto.stailer_external_admin.DeliveryTime.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.stailer_external_admin.DeliveryTime} returns this
 */
proto.stailer_external_admin.DeliveryTime.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string exclusive_user_id = 16;
 * @return {string}
 */
proto.stailer_external_admin.DeliveryTime.prototype.getExclusiveUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.stailer_external_admin.DeliveryTime} returns this
 */
proto.stailer_external_admin.DeliveryTime.prototype.setExclusiveUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string exclusive_user_name = 17;
 * @return {string}
 */
proto.stailer_external_admin.DeliveryTime.prototype.getExclusiveUserName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.stailer_external_admin.DeliveryTime} returns this
 */
proto.stailer_external_admin.DeliveryTime.prototype.setExclusiveUserName = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional bool is_deletable = 18;
 * @return {boolean}
 */
proto.stailer_external_admin.DeliveryTime.prototype.getIsDeletable = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 18, false));
};


/**
 * @param {boolean} value
 * @return {!proto.stailer_external_admin.DeliveryTime} returns this
 */
proto.stailer_external_admin.DeliveryTime.prototype.setIsDeletable = function(value) {
  return jspb.Message.setProto3BooleanField(this, 18, value);
};


/**
 * repeated type.DeliveryFeeRange delivery_fee_ranges = 19;
 * @return {!Array<!proto.type.DeliveryFeeRange>}
 */
proto.stailer_external_admin.DeliveryTime.prototype.getDeliveryFeeRangesList = function() {
  return /** @type{!Array<!proto.type.DeliveryFeeRange>} */ (
    jspb.Message.getRepeatedWrapperField(this, type_delivery_fee_range_pb.DeliveryFeeRange, 19));
};


/**
 * @param {!Array<!proto.type.DeliveryFeeRange>} value
 * @return {!proto.stailer_external_admin.DeliveryTime} returns this
*/
proto.stailer_external_admin.DeliveryTime.prototype.setDeliveryFeeRangesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 19, value);
};


/**
 * @param {!proto.type.DeliveryFeeRange=} opt_value
 * @param {number=} opt_index
 * @return {!proto.type.DeliveryFeeRange}
 */
proto.stailer_external_admin.DeliveryTime.prototype.addDeliveryFeeRanges = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 19, opt_value, proto.type.DeliveryFeeRange, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.stailer_external_admin.DeliveryTime} returns this
 */
proto.stailer_external_admin.DeliveryTime.prototype.clearDeliveryFeeRangesList = function() {
  return this.setDeliveryFeeRangesList([]);
};


/**
 * optional type.PriceType delivery_fee_type = 20;
 * @return {!proto.type.PriceType}
 */
proto.stailer_external_admin.DeliveryTime.prototype.getDeliveryFeeType = function() {
  return /** @type {!proto.type.PriceType} */ (jspb.Message.getFieldWithDefault(this, 20, 0));
};


/**
 * @param {!proto.type.PriceType} value
 * @return {!proto.stailer_external_admin.DeliveryTime} returns this
 */
proto.stailer_external_admin.DeliveryTime.prototype.setDeliveryFeeType = function(value) {
  return jspb.Message.setProto3EnumField(this, 20, value);
};


/**
 * optional Status status = 22;
 * @return {!proto.stailer_external_admin.DeliveryTime.Status}
 */
proto.stailer_external_admin.DeliveryTime.prototype.getStatus = function() {
  return /** @type {!proto.stailer_external_admin.DeliveryTime.Status} */ (jspb.Message.getFieldWithDefault(this, 22, 0));
};


/**
 * @param {!proto.stailer_external_admin.DeliveryTime.Status} value
 * @return {!proto.stailer_external_admin.DeliveryTime} returns this
 */
proto.stailer_external_admin.DeliveryTime.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 22, value);
};


/**
 * optional int64 avoid_order_assign_delivery_car_count = 23;
 * @return {number}
 */
proto.stailer_external_admin.DeliveryTime.prototype.getAvoidOrderAssignDeliveryCarCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 23, 0));
};


/**
 * @param {number} value
 * @return {!proto.stailer_external_admin.DeliveryTime} returns this
 */
proto.stailer_external_admin.DeliveryTime.prototype.setAvoidOrderAssignDeliveryCarCount = function(value) {
  return jspb.Message.setProto3IntField(this, 23, value);
};


/**
 * optional bool is_published = 24;
 * @return {boolean}
 */
proto.stailer_external_admin.DeliveryTime.prototype.getIsPublished = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 24, false));
};


/**
 * @param {boolean} value
 * @return {!proto.stailer_external_admin.DeliveryTime} returns this
 */
proto.stailer_external_admin.DeliveryTime.prototype.setIsPublished = function(value) {
  return jspb.Message.setProto3BooleanField(this, 24, value);
};


/**
 * optional string shop_id = 25;
 * @return {string}
 */
proto.stailer_external_admin.DeliveryTime.prototype.getShopId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 25, ""));
};


/**
 * @param {string} value
 * @return {!proto.stailer_external_admin.DeliveryTime} returns this
 */
proto.stailer_external_admin.DeliveryTime.prototype.setShopId = function(value) {
  return jspb.Message.setProto3StringField(this, 25, value);
};


/**
 * repeated DeliveryAreaGroup delivery_area_groups = 26;
 * @return {!Array<!proto.stailer_external_admin.DeliveryAreaGroup>}
 */
proto.stailer_external_admin.DeliveryTime.prototype.getDeliveryAreaGroupsList = function() {
  return /** @type{!Array<!proto.stailer_external_admin.DeliveryAreaGroup>} */ (
    jspb.Message.getRepeatedWrapperField(this, stailer_externaladminrpc_delivery_area_group_pb.DeliveryAreaGroup, 26));
};


/**
 * @param {!Array<!proto.stailer_external_admin.DeliveryAreaGroup>} value
 * @return {!proto.stailer_external_admin.DeliveryTime} returns this
*/
proto.stailer_external_admin.DeliveryTime.prototype.setDeliveryAreaGroupsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 26, value);
};


/**
 * @param {!proto.stailer_external_admin.DeliveryAreaGroup=} opt_value
 * @param {number=} opt_index
 * @return {!proto.stailer_external_admin.DeliveryAreaGroup}
 */
proto.stailer_external_admin.DeliveryTime.prototype.addDeliveryAreaGroups = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 26, opt_value, proto.stailer_external_admin.DeliveryAreaGroup, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.stailer_external_admin.DeliveryTime} returns this
 */
proto.stailer_external_admin.DeliveryTime.prototype.clearDeliveryAreaGroupsList = function() {
  return this.setDeliveryAreaGroupsList([]);
};


/**
 * optional type.ReceiveMethod receive_method = 27;
 * @return {?proto.type.ReceiveMethod}
 */
proto.stailer_external_admin.DeliveryTime.prototype.getReceiveMethod = function() {
  return /** @type{?proto.type.ReceiveMethod} */ (
    jspb.Message.getWrapperField(this, type_receive_method_pb.ReceiveMethod, 27));
};


/**
 * @param {?proto.type.ReceiveMethod|undefined} value
 * @return {!proto.stailer_external_admin.DeliveryTime} returns this
*/
proto.stailer_external_admin.DeliveryTime.prototype.setReceiveMethod = function(value) {
  return jspb.Message.setWrapperField(this, 27, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.stailer_external_admin.DeliveryTime} returns this
 */
proto.stailer_external_admin.DeliveryTime.prototype.clearReceiveMethod = function() {
  return this.setReceiveMethod(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.stailer_external_admin.DeliveryTime.prototype.hasReceiveMethod = function() {
  return jspb.Message.getField(this, 27) != null;
};


goog.object.extend(exports, proto.stailer_external_admin);
